module.exports = __webpack_public_path__ + "public/img/明星产品_EN.a929c403.png";